module.exports = __webpack_public_path__ + "static/19.2-89a9b982b1422ae2c6617999ecb31655.jpg";